/**
 * 直営サロンのLocation名エイリアス（移行期の吸収層）
 *
 * バリアントメタフィールド `salon.stocks[].store` には、Shopify の Location 名が
 * Flow 経由でそのまま書き込まれる。一方、店舗情報は shop メタフィールド
 * `global.own_salon` の `name` と名前で突合しているため、サロン改名によって
 * 両者が食い違い、直営サロンが取扱店舗として表示されなくなった。
 *
 * Location 名を変更しても、保存済みのメタフィールドは次の在庫変動で Flow が
 * 再書き込みするまで旧名のまま残る。そのため読み取り時に新名称へ正規化する。
 *
 * ※ 全商品の salon.stocks のバックフィルが完了したら、この吸収層は削除してよい。
 */
window.SALON_NAME_ALIASES = {
  東京サロン: '東京本店 品川サロン',
  大阪サロン: '心斎橋サロン',
};

window.normalizeSalonName = function (name) {
  return window.SALON_NAME_ALIASES[name] ?? name;
};
